// wahala.io's addresses (docs/wahala-io-urls.md): the website's pages, the landing pages for
// campaigns, the short links that go straight into the game on production, the way out to Lagos
// Life and the production hosts behind them. The website's nginx (website repo,
// server/nginx/wahala-site.conf) makes each redirect work and its deploy checks every one; the park
// office's Links screen lists them from here and checks them again from the server. Keep the three
// in step: a new link is a line here, a location there and a line in the doc.
export const SITE = 'https://wahala.io';
/** Production's game: every redirect under /play and /p lands here. */
export const PLAY_HOST = 'https://wahala-play.stiglabs.net';
export const SITE_LINKS = [
    { kind: 'page', path: '/', what: 'The home page: the games, how to play, park money and the FAQ.', to: null },
    { kind: 'page', path: '/fair-play/', what: 'How stake tables work and the limits.', to: null },
    { kind: 'page', path: '/press/', what: 'The press kit: fact sheet, screenshots, logos and colours.', to: null },
    { kind: 'page', path: '/news/', what: 'The newsletter sign-up (double opt-in, through Brevo).', to: null },
    { kind: 'page', path: '/privacy/', what: 'Privacy.', to: null },
    { kind: 'page', path: '/terms/', what: 'Terms.', to: null },
    { kind: 'page', path: '/poster/', what: 'The printable A4 poster with its QR code. Not in search.', to: null },
    {
        kind: 'landing',
        path: '/l/friends/',
        what: 'Play with your people: open a park, send the code. For group-chat and party campaigns.',
        to: null,
    },
    {
        kind: 'landing',
        path: '/l/vio/',
        what: 'The Park: find the VIO before the VIO finds you. For the main game.',
        to: null,
    },
    { kind: 'landing', path: '/l/race/', what: 'Race: three laps of Third Mainland. For the race.', to: null },
    {
        kind: 'landing',
        path: '/l/cash/',
        what: 'COMPETE AND WIN CASH on Saturdays. Coming soon: its button signs people up for the news.',
        to: null,
    },
    {
        kind: 'game',
        path: '/play',
        what: 'The game, on its first screen. Ads and buttons point here.',
        to: `${PLAY_HOST}/`,
    },
    {
        kind: 'game',
        path: '/play/install',
        what: 'The game with its install sheet open (Get the app).',
        to: `${PLAY_HOST}/?install=1`,
    },
    {
        kind: 'game',
        path: '/play/today',
        what: "Today's challenges (a new player picks a name first).",
        to: `${PLAY_HOST}/?open=today`,
    },
    { kind: 'game', path: '/play/board', what: 'The rankings board.', to: `${PLAY_HOST}/?open=board` },
    { kind: 'game', path: '/play/shop', what: 'The shop.', to: `${PLAY_HOST}/?open=shop` },
    { kind: 'game', path: '/play/pass', what: 'The Route Pass.', to: `${PLAY_HOST}/?open=pass` },
    {
        kind: 'game',
        path: '/p/{CODE}',
        what: 'A park invite: joins that park once the player is signed in. The game makes these.',
        to: `${PLAY_HOST}/?park={CODE}`,
        sample: '/p/ABC234',
    },
    {
        kind: 'out',
        path: '/go/lagos-life',
        what: 'Out to Lagos Life (counted in the access log). Point it at the listing when it is live.',
        to: 'https://lagoslife.app',
    },
];
/** The screens a /play/{screen} link opens (apps/web lib/push takeOpening reads ?open=). */
export const OPEN_SCREENS = ['today', 'board', 'shop', 'pass'];
/** Production's own addresses, for reference. */
export const PRODUCTION_HOSTS = [
    { name: 'Website', url: `${SITE}/`, what: 'The product website (static, behind Cloudflare).' },
    { name: 'Game', url: `${PLAY_HOST}/`, what: 'The phone client. Every wahala.io short link lands here.' },
    { name: 'Api', url: `${PLAY_HOST}/api/v1/health`, what: 'The api, same host, under /api/v1.' },
    { name: 'Park office', url: 'https://wahala-office.stiglabs.net/', what: 'This office, on the team VPN only.' },
    { name: 'Website stats', url: `${SITE}/stats/`, what: 'GoAccess from the access logs, behind a password.' },
];
/** Campaign tags a link may carry. The game keeps them with each new player (apps/web lib/campaign). */
export const CAMPAIGN_TAGS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
/** A tag value: lower case, digits and hyphens, so the stats group it one way. */
export const tagValue = (v) => v
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
/** A wahala.io link with campaign tags: `campaignUrl('/l/friends/', { utm_source: 'whatsapp' })`. */
export function campaignUrl(path, tags = {}) {
    if (!path.startsWith('/') || path.includes('{'))
        throw new RangeError('not a wahala.io path');
    const q = new URLSearchParams();
    for (const k of CAMPAIGN_TAGS) {
        const v = tags[k] ? tagValue(tags[k]) : '';
        if (v)
            q.set(k, v);
    }
    const s = q.toString();
    return `${SITE}${path}${s ? `?${s}` : ''}`;
}
/** Where a redirect should land for a request with this query: the target with the query added. */
export function expectedLanding(link, query = '') {
    if (!link.to)
        return null;
    const sample = link.sample ? link.sample.split('/').pop() : null;
    const to = sample ? link.to.replace('{CODE}', sample) : link.to;
    if (!query)
        return to;
    return `${to}${to.includes('?') ? '&' : '?'}${query}`;
}
//# sourceMappingURL=links.js.map